import { requestMatch } from '../premium/requestMatch';
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaHeart,
  FaTh,
  FaUser,
  FaSearch,
  FaThumbtack,
  FaComment,
  FaHeartBroken,
  FaTimes,
  FaBars,
  FaCog,
  FaBriefcase,
  FaShieldAlt,
  FaSignOutAlt,
  FaRegFileAlt,
  FaVideo
  ,FaHome
  ,FaUserFriends
  ,FaNetworkWired
  ,FaShareAlt
  ,FaCopy
  ,FaPaperPlane
} from "react-icons/fa";
import "./SportProfile.css";
import { get, post, deleteRequest } from "../http/api";
import PostModal from "./PostModal";
import { useTranslation } from "react-i18next";
import { UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";
import { useLoginRequiredModal } from "../components/reusable/LoginRequiredContext";
import VerifiedBadge from "../components/reusable/VerifiedBadge";
import { clearRememberedSession, deleteData } from "../store/Store";
import { unregisterMobilePush } from "../mobile/MobileRuntime";





export default function SportProfile({
  highlightedCommentId,

}) {

  const { username } = useParams();

  const { t } = useTranslation();

  const {
    openLoginModal
  } = useLoginRequiredModal();

  const isAuthenticated =
    !!sessionStorage.getItem("id_user");

  const requireAuth = (callback) => {

    if (!isAuthenticated) {
      openLoginModal();
      return;
    }

    callback();
  };


  const currentUserId = Number(sessionStorage.getItem("id_user"));
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("posts");
  const [showNativeProfileMenu, setShowNativeProfileMenu] = useState(false);
  const [profile, setProfile] = useState(null);
  const [isProfilePhotoOpen, setIsProfilePhotoOpen] = useState(false);
  const [showProfileShare, setShowProfileShare] = useState(false);
  const [shareMatches, setShareMatches] = useState([]);
  const [shareSelected, setShareSelected] = useState([]);
  const [shareSending, setShareSending] = useState(false);
  const [shareFeedback, setShareFeedback] = useState("");

  const [profileId, setProfileId] = useState(null);

  const [isFollowing, setIsFollowing] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  const [followersCount, setFollowersCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [loadingData, setLoadingData] = useState(true);
  const [matchStatus, setMatchStatus] = useState("none");
  const [posts, setPosts] = useState([]);
  const storedCurrentUser = sessionStorage.getItem("user");
  const currentUser = storedCurrentUser ? JSON.parse(storedCurrentUser) : null;

  const handleNativeLogout = async () => {
    await unregisterMobilePush();
    clearRememberedSession();
    deleteData("id_user");
    deleteData("token");
    deleteData("user");
    navigate("/login");
  };


  const [openedPostId, setOpenedPostId] = useState(null);
  const [openedPost, setOpenedPost] = useState(null);
  const [openCommentsOnModal, setOpenCommentsOnModal] = useState(false);

  const [isClosing, setIsClosing] = useState(false);

  const publicProfileUrl = `${window.location.origin}/user/${profile?.username || username}`;

  const openProfileShare = async () => {
    setShowProfileShare(true);
    setShareSelected([]);
    setShareFeedback("");
    if (!isAuthenticated) return;
    try {
      const response = await get("matches");
      setShareMatches(Array.isArray(response.data) ? response.data : []);
    } catch (_) {
      setShareMatches([]);
    }
  };

  const copyProfileLink = async () => {
    await navigator.clipboard.writeText(publicProfileUrl);
    setShareFeedback(t("sportProfile.share.copied"));
  };

  const shareProfileExternal = async () => {
    if (navigator.share) {
      await navigator.share({
        title: t("sportProfile.share.title"),
        text: t("sportProfile.share.discover", { username: profile?.username || username }),
        url: publicProfileUrl
      });
    } else {
      await copyProfileLink();
    }
  };

  const sendProfileToMatches = async () => {
    if (!shareSelected.length || shareSending) return;
    setShareSending(true);
    try {
      await Promise.all(shareSelected.map(receiver_id => post("messages", {
        receiver_id,
        type: "profile",
        message: publicProfileUrl
      })));
      setShareFeedback(t("sportProfile.share.sent"));
      setShareSelected([]);
    } catch (_) {
      setShareFeedback(t("sportProfile.share.error"));
    } finally {
      setShareSending(false);
    }
  };

  const [highlights, setHighlights] = useState([]);
  const [highlightsLoading, setHighlightsLoading] = useState(true);

  useEffect(() => {
    if (!isProfilePhotoOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsProfilePhotoOpen(false);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isProfilePhotoOpen]);


  const fetchHighlights = async () => {
    if (!profileId) return;

    setHighlightsLoading(true);

    try {
      const res = await get(`profile/${profileId}/highlights`);
      setHighlights(res.data || []);
    } catch (err) {
      console.error(err);
      setHighlights([]);
    } finally {
      setHighlightsLoading(false);
    }
  };

  useEffect(() => {
    fetchHighlights();
  }, [profileId]);


  const [showFollowModal, setShowFollowModal] = useState(false);
  const [followType, setFollowType] = useState("followers");
  const [followList, setFollowList] = useState([]);
  const [search, setSearch] = useState("");
  const [error, setError] = useState('');


  const imagePosts = posts.filter(post => post.type === "image");
  const textPosts = posts.filter(
    post => post.type === "text" || post.type === "link"
  );
  const videoPosts = posts.filter(post => post.type === "video");



  useEffect(() => {
    if (!profileId) return;

    fetchFollowCounts();

    if (profileId !== currentUserId) {
      fetchFollowStatus();
    }

  }, [profileId]);

  const fetchFollowStatus = async () => {
    const res = await get(`follows/status/${profileId}`);
    setIsFollowing(res.message === "FOLLOWING");
  };

  const fetchFollowCounts = async () => {
    const res = await get(`follows/count/${profileId}`);
    setFollowersCount(res.data.followers);
    setFollowingCount(res.data.following);
  };


  const fetchFollowList = async (type) => {
    try {
      const res = await get(`follows/${type}/${profileId}`, {
        headers: {
          "x-access-id_user": currentUserId
        }
      });

      setFollowList(
        (res.data || []).map(u => ({
          ...u,
          isFollowing: Boolean(u.isFollowing)
        }))
      );

    } catch (err) {
      console.error(err);
    }
  };

  const openFollowModal = async (type) => {
    setFollowType(type);
    setShowFollowModal(true);
    await fetchFollowList(type);
  };

  const filteredList = followList.filter(user =>
    user.username.toLowerCase().includes(search.toLowerCase())
  );


  const handleFollow = async () => {
    if (followLoading) return;

    try {
      setFollowLoading(true);
      await post(`follows/${profileId}`);
      setIsFollowing(true);
      await fetchFollowCounts();
    } catch (err) {
      console.error("followUser error:", err);
    } finally {
      setFollowLoading(false);
    }
  };

  const handleUnfollow = async () => {
    if (followLoading) return;

    try {
      setFollowLoading(true);
      await deleteRequest(`follows/${profileId}`);
      setIsFollowing(false);
      await fetchFollowCounts();
    } catch (err) {
      console.error("unfollowUser error:", err);
    } finally {
      setFollowLoading(false);
    }
  };


  const toggleFollow = async (user) => {
    try {
      const wasFollowing = user.isFollowing;

      setFollowList(prev =>
        prev.map(u =>
          u.id_user === user.id_user
            ? { ...u, isFollowing: !wasFollowing }
            : u
        )
      );

      setFollowingCount(prev =>
        wasFollowing ? prev - 1 : prev + 1
      );

      if (wasFollowing) {
        await deleteRequest(`follows/${user.id_user}`);
      } else {
        await post(`follows/${user.id_user}`);
      }

    } catch (err) {
      console.error(err);

      setFollowList(prev =>
        prev.map(u =>
          u.id_user === user.id_user
            ? { ...u, isFollowing: user.isFollowing }
            : u
        )
      );

      setFollowingCount(prev =>
        user.isFollowing ? prev + 1 : prev - 1
      );
    }
  };


  useEffect(() => {
    if (!username) return;

    let requestIsCurrent = true;
    const requestedUsername = username;

    const cachedOwnProfile = currentUser?.username === requestedUsername
      ? { ...currentUser, id_user: currentUser.id_user || currentUserId }
      : null;

    setLoadingData(!cachedOwnProfile);
    setProfile(cachedOwnProfile);
    setProfileId(cachedOwnProfile?.id_user || null);
    setPosts([]);
    setHighlights([]);
    setFollowersCount(0);
    setFollowingCount(0);
    setIsFollowing(false);
    setMatchStatus("none");

    fetchPublicProfile(requestedUsername, () => requestIsCurrent);

    return () => {
      requestIsCurrent = false;
    };

  }, [username]);

  const fetchPublicProfile = async (requestedUsername, isCurrent = () => true) => {
    try {
      const res = await get(
        `profile/username/${encodeURIComponent(requestedUsername)}`
      );

      if (!isCurrent()) return;

      if (!res?.data?.id_user) {
        throw new Error("PROFILE_DATA_INVALID");
      }

      setProfile(res.data);
      setProfileId(res.data.id_user);
    } catch (err) {
      console.error(err);
      if (isCurrent()) {
        setProfile(null);
        setProfileId(null);
      }
    } finally {
      if (isCurrent()) setLoadingData(false);
    }
  };


  useEffect(() => {
    if (!profileId) return;

    fetchUserPosts();

  }, [profileId]);

  const fetchUserPosts = async () => {
    try {

      const res = await get(`posts/user/${profileId}`);
      setPosts(

        (res.data || [])
          .sort(
            (a, b) =>

              b.is_pinned -
              a.is_pinned
          )

      );

    } catch (err) {
      console.error(err);
    }
  };


  useEffect(() => {
    if (!profileId || profileId === currentUserId) return;
    fetchMatchStatus();
  }, [profileId]);

  const fetchMatchStatus = async () => {
    try {
      const res = await get(`matches/status/${profileId}`);

      const status =
        res?.data?.status && ["none", "sent", "received", "matched"].includes(res.data.status)
          ? res.data.status
          : "none";

      setMatchStatus(status);

    } catch (err) {
      console.error("fetchMatchStatus error:", err);
      setMatchStatus("none");
    }
  };


  const handleMatch = async () => {
    try {
      setError("");

      const res = await requestMatch(profileId);
      if (!res) return;

      if (res?.data?.status) {
        setMatchStatus(res.data.status);
      }

    } catch (err) {
      if (err.message === "MATCH_NOT_ALLOWED") {
        setError(
          t("sportProfile.errors.fansOnly")
        );
      } else {
        setError(
          t("sportProfile.errors.generic")
        );
      }
    }
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError("");
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleAcceptMatch = async () => {
    if (!(await requestMatch(profileId))) return;
    fetchMatchStatus();
  };

  const handleUnmatch = async () => {
    await deleteRequest(`matches/unmatch/${profileId}`);
    setMatchStatus("none");
  };

  const handleMessage = () => {

    navigate("/home", {
      state: {
        openMessages: true,
        selectedUser: profileId,
        selectedUsername: profile.username,
        selectedUserPhoto: profile.image,
        fromProfile: true
      }
    });
    // navigate("/home", {
    //   state: {
    //     openMessages: true,
    //     selectedUser: profileId,
    //     fromProfile: true
    //   }
    // });
  };


  const stats = [
    {
      type: "posts",
      label: t("sportProfile.stats.posts"),
      value: posts.length
    },
    {
      type: "followers",
      label: t("sportProfile.stats.followers"),
      value: followersCount
    },
    {
      type: "following",
      label: t("sportProfile.stats.following"),
      value: followingCount
    }
  ];


  const lawyerStatuses =
    profile?.role === "lawyer" &&
      profile?.sport_profile?.status
      ? JSON.parse(profile.sport_profile.status)
      : [];


  const displayName =
    profile?.role === "brand" &&
      profile?.sport_profile?.brand_name
      ? profile.sport_profile.brand_name

      : profile?.role === "media" &&
        profile?.sport_profile?.type === "mediaForm.company" &&
        profile?.sport_profile?.company_name
        ? profile.sport_profile.company_name

        : profile?.display_name;

  const displayRole =
    profile?.role === "brand" &&
      profile?.sport_profile?.sector
      ? t(profile.sport_profile.sector)

      : profile?.role === "lawyer"
        ? lawyerStatuses.map(s => t(s)).join(" • ")

        : profile?.role === "staff"
          ? t(profile?.sport_profile?.status || "")

          : profile?.role === "media"
            ? (
              profile?.sport_profile?.type === "mediaForm.company"
                ? t(profile?.sport_profile?.type)
                : t(profile?.sport_profile?.status || "")
            )

            : profile?.role;


  // const displayRole =
  //   profile?.role === "lawyer"
  //     ? lawyerStatuses.map(s => t(s)).join(" • ")

  //     : profile?.role === "staff"
  //       ? t(profile?.sport_profile?.status || "")

  //       : profile?.role === "media"
  //         ? (
  //           profile?.sport_profile?.type === "mediaForm.company"
  //             ? t(profile?.sport_profile?.type)
  //             : t(profile?.sport_profile?.status || "")
  //         )

  //         : profile?.role;

  // const displayName =
  //   profile?.role === "media" &&
  //     profile?.sport_profile?.type === "mediaForm.company" &&
  //     profile?.sport_profile?.company_name
  //     ? profile.sport_profile.company_name
  //     : profile?.display_name;

  return (
    <div className="pro-profile-container">
      <div className="profile-container">

        <div className="sport-profile-topbar">

          <button
            className="sport-back-btn"
            onClick={() => navigate(-1)}
          >
            <span className="back-arrow">←</span>

            <div className="back-content">
              <span className="back-label">
                {t("sportProfile.back.label")}
              </span>

              <small>
                {t("sportProfile.back.subtitle")}
              </small>
            </div>
          </button>

          {profileId === currentUserId && (
            <div className="native-profile-menu-wrap">
              <button className="native-profile-menu-trigger" type="button" onClick={() => setShowNativeProfileMenu((open) => !open)} aria-label="Menu">
                {showNativeProfileMenu ? <FaTimes /> : <FaBars />}
              </button>
              {showNativeProfileMenu && (
                <>
                  <button className="native-profile-menu-backdrop" type="button" aria-label="Fermer" onClick={() => setShowNativeProfileMenu(false)} />
                  <div className="native-profile-menu">
                    <button type="button" onClick={() => navigate("/profile/settings")}><FaCog /><span>{t("navbar.settings")}</span></button>
                    {currentUser?.role === "club" && <button type="button" onClick={() => navigate("/offers")}><FaBriefcase /><span>{t("navbar.offers")}</span></button>}
                    {Number(currentUser?.isAdmin) === 1 && <button type="button" onClick={() => navigate("/admin")}><FaShieldAlt /><span>Administration</span></button>}
                    <button className="native-profile-logout" type="button" onClick={handleNativeLogout}><FaSignOutAlt /><span>{t("navbar.logout")}</span></button>
                  </div>
                </>
              )}
            </div>
          )}

        </div>


        <div className="main-profile-header">
          <div className="profile-header">
            <div
              className={`photo-wow ${profile?.image ? "photo-wow-clickable" : ""}`}
              onClick={() => profile?.image && setIsProfilePhotoOpen(true)}
              onKeyDown={(event) => {
                if (profile?.image && (event.key === "Enter" || event.key === " ")) {
                  event.preventDefault();
                  setIsProfilePhotoOpen(true);
                }
              }}
              role={profile?.image ? "button" : undefined}
              tabIndex={profile?.image ? 0 : undefined}
              aria-label={profile?.image ? t("sportProfile.photo.open") : undefined}
            >

              {loadingData ? (
                <div className="skeleton skeleton-avatar"></div>
              ) : profile?.image ? (
                <img
                  // src={`${UPLOADS_URL}/${profile.image}`}
                  src={getMediaUrl(profile.image)}
                  alt={profile.username}
                />
              ) : (
                <FaUser color="white" style={{ width: "50px", height: "50px" }} />
              )}

            </div>

            <div className="profile-info">
              {loadingData ? (
                <div className="skeleton" style={{ width: "120px", height: "18px" }} />
              ) : (
                <div className="profile-display-name">
                  <h2>{displayName}</h2>
                  <VerifiedBadge
                    verified={Number(profile?.is_verified) === 1}
                    className="verified-badge--profile"
                  />
                </div>
                // <h1>
                //   {`${profile?.profile?.first_name || profile?.first_name || ""}
                //     ${profile?.profile?.last_name || profile?.last_name || ""}`.trim()}
                // </h1>
              )}

              {loadingData ? (
                <div className="skeleton" style={{ width: "160px", height: "14px" }} />
              ) : (
                <p className="bio">
                  {displayRole || t("sportProfile.defaultRole")}
                </p>
              )}

              <div className="stats">
                {stats.map((s) => (
                  <div
                    key={s.label}
                    onClick={() => {
                      if (s.type === "followers")
                        // openFollowModal("followers");
                        requireAuth(() =>
                          openFollowModal("followers")
                        );

                      if (s.type === "following")
                        // openFollowModal("following");
                        requireAuth(() =>
                          openFollowModal("following")
                        );
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{s.value}</strong>
                    <span>{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={`profile-summary ${profile?.public?.bio ? "" : "profile-summary-empty"}`}>
            {profile?.public?.bio && (
              <p className="profile-bio">
                {profile.public.bio}
              </p>
            )}
          </div>
          {(profile?.public?.link1 || profile?.public?.link2) && (

            <div className="profile-links-section">

              <h4 className="profile-links-title">
                {t("sportProfile.links.title")}
              </h4>

              <div className="profile-links">

                {[profile.public.link1, profile.public.link2]
                  .filter(Boolean)
                  .map((link, index) => {

                    const formattedLink =
                      link.startsWith("http")
                        ? link
                        : `https://${link}`;

                    return (
                      <a
                        key={index}
                        href={formattedLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="profile-link"
                      >
                        {link}
                      </a>
                    );
                  })}

              </div>

            </div>

          )}
        </div>


        <div className="cta-buttons">

          <button
            type="button"
            className="btn secondary profile-share-btn"
            onClick={openProfileShare}
          >
            <FaShareAlt />
            {t("sportProfile.share.action")}
          </button>

          {profileId === currentUserId && (
            <button
              className="btn primary profile-edit-btn"
              onClick={() => navigate("/profile/settings")}
            >
              {t("sportProfile.actions.editProfile")}
            </button>
          )}

          {profileId && profileId !== currentUserId && (
            <>
              <button
                type="button"
                className="btn secondary"
                disabled={followLoading}
                // onClick={isFollowing ? handleUnfollow : handleFollow}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  requireAuth(() =>
                    isFollowing
                      ? handleUnfollow()
                      : handleFollow()
                  );
                }}
              >
                {isFollowing
                  ? t("sportProfile.actions.following")
                  : t("sportProfile.actions.follow")
                }
              </button>

              {matchStatus === "matched" && (
                <>
                  <button className="btn primary"
                    type="button"
                    onClick={() =>
                      requireAuth(handleMessage)
                    }
                  //  onClick={handleMessage}
                  >
                    <FaComment /> {t("sportProfile.actions.message")}
                  </button>
                  <button className="btn secondary"
                    type="button"
                    onClick={() =>
                      requireAuth(handleUnmatch)
                    }
                  // onClick={handleUnmatch}
                  >
                    <FaHeartBroken /> {t("sportProfile.actions.removeMatch")}
                  </button>
                </>
              )}

              {matchStatus === "sent" && (
                <button className="btn secondary"
                  type="button"
                  onClick={() =>
                    requireAuth(handleUnmatch)
                  }
                //  onClick={handleUnmatch}
                >
                  <FaHeart /> {t("sportProfile.actions.matchSent")}
                </button>
              )}

              {matchStatus === "received" && (
                <button className="btn primary"
                  type="button"
                  onClick={() =>
                    requireAuth(handleAcceptMatch)
                  }
                //  onClick={handleAcceptMatch}
                >
                  <FaHeart /> {t("sportProfile.actions.match")}
                </button>
              )}

              {matchStatus === "none" && (
                <button className="btn primary"
                  type="button"
                  onClick={() =>
                    requireAuth(handleMatch)
                  }
                //  onClick={handleMatch}
                >
                  <FaHeart /> {t("sportProfile.actions.match")}
                </button>
              )}
            </>
          )}

        </div>

        {error &&
          <div className="error-login-message" style={{ width: "92%", margin: "0 auto", marginTop: "10px" }}>
            ⚠️ {error}
          </div>
        }

        <div className="highlights-section">
          {highlightsLoading ? (
            <div className="highlights-section">
              <div className="highlights-list">
                {Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="highlight-card skeleton-highlight">
                    <div className="skeleton-dot skeleton"></div>

                    <div
                      className="skeleton"
                      style={{
                        height: "14px",
                        width: `${70 + i * 10}%`,
                        borderRadius: "8px",
                        margin: 0
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : highlights.length > 0 ? (
            <div className="highlights-section">
              <div className="highlights-list">
                {highlights.map((item, index) => (
                  <div key={index} className="highlight-card">
                    <span className="highlight-dot"></span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

        </div>

        <div className="tabs">
          {['posts', 'publications', 'videos'].map(tab => (

            <button
              key={tab}
              className={activeTab === tab ? "active" : ""}

              onClick={() => {

                if (activeTab === tab) {

                  fetchUserPosts();

                } else {

                  setActiveTab(tab);
                  fetchUserPosts();

                }

              }}

            >
              {/* {tab.toUpperCase()} */}
              <span className="profile-tab-label">
                {tab === "posts"
                  ? t("sportProfile.tabs.posts")
                  : tab === "publications"
                    ? t("sportProfile.tabs.publications")
                    : t("sportProfile.tabs.videos")}
              </span>
              <span className="native-profile-tab-icon" aria-hidden="true">
                {tab === "posts" ? <FaTh /> : tab === "publications" ? <FaRegFileAlt /> : <FaVideo />}
              </span>
            </button>

          ))}
        </div>

        {activeTab === "posts" && (

          <div className="grid">

            {loadingData ? (

              Array.from({ length: 9 }).map((_, i) => (
                <div key={i} className="grid-skeleton skeleton"></div>
              ))

            ) : imagePosts.length === 0 ? (

              <div className="empty-state">
                <FaTh size={40} />
                <h4>
                  {t("sportProfile.empty.imagesTitle")}
                </h4>

                <p>
                  {t("sportProfile.empty.imagesDescription")}
                </p>
              </div>

            ) : (

              imagePosts.map(post => (
                <div
                  key={post.id_post}
                  className="grid-item"
                  onClick={() => {
                    requireAuth(() => {
                      setOpenedPost(post);
                      setOpenedPostId(post.id_post);
                    });
                    // setOpenedPost(post);
                    // setOpenedPostId(post.id_post);
                  }}
                >

                  {post.is_pinned === 1 && (
                    <div className="pinned-badge">
                      <FaThumbtack />
                    </div>

                  )}

                  <img
                    src={getMediaUrl(post.image)}
                    // src={`${UPLOADS_URL}/${post.image}`}
                    alt=""
                  />
                </div>
              ))

            )}

          </div>

        )}


        {openedPost && (
          <PostModal
            postId={openedPostId}

            openComments={openCommentsOnModal}

            scrollToLastComment={false}

            highlightedCommentId={highlightedCommentId}

            refreshPosts={fetchUserPosts}
            setPosts={setPosts}

            onClose={() => {
              setOpenedPostId(null);
              setOpenedPost(null);
              setOpenCommentsOnModal(false);
            }}
          />
        )}


        {activeTab === "publications" && (
          <div className="text-posts">

            {textPosts.length === 0 ? (
              <div className="empty-state">
                <FaTh size={40} />
                <h4>
                  {t("sportProfile.empty.postsTitle")}
                </h4>

                <p>
                  {t("sportProfile.empty.postsDescription")}
                </p>
              </div>
            ) : (
              textPosts.map(post => (
                <div key={post.id_post}
                  className="text-post-card"
                  onClick={() => {
                    requireAuth(() => {
                      setOpenedPost(post);
                      setOpenedPostId(post.id_post);
                    });
                    // setOpenedPost(post);
                    // setOpenedPostId(post.id_post);
                  }}
                >

                  <div className="text-post-header">
                    <div>
                      <strong>{profile.username}</strong>
                      <span className="post-date">
                        {new Date(post.created_at).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  <p className="text-post-content">
                    {post.text}
                  </p>

                  {post.link_url && (
                    <a
                      href={post.link_url}
                      target="_blank"
                      rel="noreferrer"
                      className="text-post-link"
                    >
                      {post.link_url}
                    </a>
                  )}

                  <div className="text-post-actions">

                    <span>❤️ {post.likes}</span>

                    <span>💬 {post.comments}</span>

                  </div>

                </div>
              ))
            )}

          </div>
        )}


        {activeTab === "videos" && (

          <div className="reels-grid">

            {videoPosts.length === 0 ? (

              <div className="empty-state">
                <FaTh size={40} />
                <h4>
                  {t("sportProfile.empty.videosTitle")}
                </h4>

                <p>
                  {t("sportProfile.empty.videosDescription")}
                </p>
              </div>

            ) : (

              videoPosts.map(post => (

                <div
                  key={post.id_post}
                  className="reel-item"
                  onClick={() => {
                    requireAuth(() => {
                      setOpenedPost(post);
                      setOpenedPostId(post.id_post);
                    });
                    // setOpenedPost(post);
                    // setOpenedPostId(post.id_post);
                  }}
                >

                  <video
                    src={getMediaUrl(post.video, "video")}
                    // src={`${UPLOADS_URL}/videos/${post.video}`}
                    muted
                    loop
                    playsInline
                  />

                </div>

              ))

            )}

          </div>

        )}


        {showFollowModal && (
          <div className="follow-page-overlay">

            <div className={`follow-page ${isClosing ? "closing" : ""}`}>

              <div className="follow-header">
                <button onClick={() => {
                  setIsClosing(true);
                  setTimeout(() => {
                    setShowFollowModal(false);
                    setIsClosing(false);
                  }, 300);
                }} className="back-btn">
                  ←
                </button>

                <div className="follow-title-block">
                  {/* <span className="follow-title-kicker">CarrerUp Network</span> */}
                  <h3>
                    {followType === "followers"
                      ? t("sportProfile.followModal.followers")
                      : t("sportProfile.followModal.followingg")}
                  </h3>
                </div>

                <span className="follow-count">{followList.length}</span>
              </div>

              <div className="follow-search-wrap">

                <FaSearch className="follow-search-icon" />

                <input
                  type="text"
                  placeholder={
                    t("sportProfile.followModal.search")
                  }
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="follow-search"
                />

              </div>

              <div className="follow-list">

                {filteredList.length === 0 ? (
                  <div className="follow-empty-state">
                    <div className="follow-empty-icon">
                      👥
                    </div>
                    <h4>
                      {t("sportProfile.followModal.emptyTitle")}
                    </h4>

                    <p>
                      {t("sportProfile.followModal.emptyDescription")}
                    </p>
                  </div>
                ) : (
                  filteredList.map(user => (
                    <div
                      key={user.id_user}
                      className="follow-item"
                      onClick={() => navigate(`/user/${user.username}`)}
                    >
                      <div className="follow-item-left">

                        {
                          user.image ? (
                            <img
                              src={getMediaUrl(user.image)}
                              // src={`${UPLOADS_URL}/${user.image}`}
                              alt=""
                              className="follow-avatar"
                            />
                          ) : (
                            <div className="follow-user-icon">
                              <FaUser className="flw-icon" size={20} color="white" />
                            </div>
                          )
                        }

                        <div className="follow-user-info">

                          <span className="follow-username">
                            {user.username}
                          </span>

                        </div>
                      </div>

                      {user.id_user !== currentUserId && (
                        <button
                          className={`follow-btn ${user.isFollowing ? "following" : ""}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFollow(user);
                          }}
                        >
                          {
                            user.isFollowing
                              ? t("sportProfile.followModal.following")
                              : followType === "followers"
                                ? t("sportProfile.followModal.followBack")
                                : t("sportProfile.followModal.follow")
                          }
                        </button>
                      )}

                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}

        {showProfileShare && (
          <div className="profile-share-overlay" role="dialog" aria-modal="true" onClick={() => setShowProfileShare(false)}>
            <div className="profile-share-panel" onClick={(event) => event.stopPropagation()}>
              <div className="profile-share-header">
                <div>
                  <span>{t("sportProfile.share.kicker")}</span>
                  <h3>{t("sportProfile.share.title")}</h3>
                </div>
                <button type="button" onClick={() => setShowProfileShare(false)} aria-label={t("sportProfile.share.close")}><FaTimes /></button>
              </div>
              <div className="profile-share-link">
                <span>{publicProfileUrl}</span>
                <button type="button" onClick={copyProfileLink}><FaCopy /> {t("sportProfile.share.copy")}</button>
                <button type="button" onClick={shareProfileExternal}><FaShareAlt /> {t("sportProfile.share.external")}</button>
              </div>
              {isAuthenticated && (
                <>
                  <h4>{t("sportProfile.share.matches")}</h4>
                  <div className="profile-share-matches">
                    {shareMatches.length === 0 ? (
                      <p>{t("sportProfile.share.empty")}</p>
                    ) : shareMatches.map(user => {
                      const userId = Number(user.id || user.id_user);
                      const selected = shareSelected.includes(userId);
                      return (
                        <button
                          type="button"
                          key={userId}
                          className={selected ? "selected" : ""}
                          onClick={() => setShareSelected(current => selected ? current.filter(id => id !== userId) : [...current, userId])}
                        >
                          {user.image ? <img src={getMediaUrl(user.image)} alt="" /> : <span className="profile-share-fallback"><FaUser /></span>}
                          <span>@{user.username}</span>
                          <i>{selected ? "✓" : "+"}</i>
                        </button>
                      );
                    })}
                  </div>
                  <button className="profile-share-send" type="button" disabled={!shareSelected.length || shareSending} onClick={sendProfileToMatches}>
                    <FaPaperPlane /> {shareSending ? t("sportProfile.share.sending") : t("sportProfile.share.send")}
                  </button>
                </>
              )}
              {shareFeedback && <p className="profile-share-feedback">{shareFeedback}</p>}
            </div>
          </div>
        )}

        {isProfilePhotoOpen && profile?.image && (
          <div
            className="profile-photo-viewer"
            role="dialog"
            aria-modal="true"
            aria-label={t("sportProfile.photo.viewer")}
            onClick={() => setIsProfilePhotoOpen(false)}
          >
            <div
              className="profile-photo-viewer-backdrop"
              style={{ backgroundImage: `url("${getMediaUrl(profile.image)}")` }}
              aria-hidden="true"
            />

            <button
              type="button"
              className="profile-photo-viewer-close"
              onClick={() => setIsProfilePhotoOpen(false)}
              aria-label={t("sportProfile.photo.close")}
            >
              <FaTimes />
            </button>

            <div
              className="profile-photo-viewer-content"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="profile-photo-viewer-ring">
                <img
                  src={getMediaUrl(profile.image)}
                  alt={profile.username}
                />
              </div>
              <p>{displayName}</p>
            </div>
          </div>
        )}
      </div>

      {isAuthenticated && (
        <nav className="native-profile-dock" aria-label="Navigation mobile">
          <button type="button" onClick={() => navigate("/home?tab=home")}><FaHome /><span>{t("navbar.home")}</span></button>
          <button type="button" onClick={() => navigate("/home?tab=matching")}><FaUserFriends /><span>{t("navbar.matching")}</span></button>
          <button type="button" onClick={() => navigate("/home?tab=search")}><FaSearch /><span>{t("navbar.search")}</span></button>
          <button type="button" onClick={() => navigate("/home?tab=network")}><FaNetworkWired /><span>{t("navbar.network")}</span></button>
          <button className="active" type="button"><FaUser /><span>{t("navbar.profile")}</span></button>
        </nav>
      )}
    </div>

  );
}
